// removed by extract-text-webpack-plugin
module.exports = {"placeholder":"encoding-shelf__placeholder","placeholder-over":"encoding-shelf__placeholder-over","placeholder-active":"encoding-shelf__placeholder-active","placeholder-disabled":"encoding-shelf__placeholder-disabled","encoding-shelf":"encoding-shelf__encoding-shelf","wildcard-shelf":"encoding-shelf__wildcard-shelf","field-wrapper":"encoding-shelf__field-wrapper","shelf-label":"encoding-shelf__shelf-label","overlay-screen":"encoding-shelf__overlay-screen"};


//////////////////
// WEBPACK FOOTER
// ./src/components/encoding-pane/encoding-shelf.scss
// module id = 1216
// module chunks = 0